module.exports = __webpack_public_path__ + "img/collection-weddingRingsCeramic@2x.4c2bb25.webp";